<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-bank</v-icon>
                <span class="title font-weight-light">Movimentação Bancária</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="Listar()" v-on="on"><v-icon>mdi-text-box-search</v-icon></v-btn>
                    </template>
                    <span>Consultar</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>

            <v-card-text class="mt-3">

                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-autocomplete v-model="filtro.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="6">
                        <fieldset class="px-2">
                            <legend>Código:</legend>
                            <v-row class="mt-2">
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field type="number" v-model.number="filtro.codigoInicio" label="De:" dense outlined/>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field type="number" v-model.number="filtro.codigoFim" label="Até:" dense outlined/>
                                </v-col>
                            </v-row>
                        </fieldset>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <fieldset class="px-2">
                            <legend>Data:</legend>
                            <v-row class="mt-2">
                                <v-col cols="12" sm="6" md="6">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.dataInicial" label="Data de Início" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.dataInicial" no-title/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="filtro.dataFinal" label="Data de Início" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="filtro.dataFinal" no-title/>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </fieldset>
                    </v-col>
                </v-row>

                <v-row class="mt-4">
                    <v-col cols="12" sm="12" md="4">
                        <v-autocomplete v-model="filtro.fornecedorId" :items="fornecedores" :loading="isFornecedorLoading" :search-input.sync="onSearchFornecedor" clearable
                          item-text="nome" item-value="id" label="Fornecedor" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.tipo" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="filtro.layoutId" label="Layout" :items="layouts" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                </v-row>

                <v-card class="pa-2 mt-2" color="primary">
                    <v-row class="text">                        
                        <v-col cols="12" sm="6" md="3">
                            Saldo Inicial: R${{item.saldoInicial ? item.saldoInicial.toMoeda() : 0}}
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            Saída: R${{item.totalSaida ? item.totalSaida.toMoeda() : 0}}
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            Entradas: R${{item.totalEntrada ? item.totalEntrada.toMoeda() : 0}}
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            Saldo Atual: R${{item.saldoAtual ? item.saldoAtual.toMoeda() : 0}}
                        </v-col>                        
                    </v-row>
                </v-card>

                <v-card class="mt-5" v-if="item.items ? item.items.length > 0 : false">
                    <v-card-text class="pa-2">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table id="tabela" dense class="py-2 text-caption">
                                    <template v-slot: default>
                                        <thead class="fonte" style="background-color: #4A70A8">
                                            <tr>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Código</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Nome</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Descrição</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Data</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Cheque</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Entrada</th>
                                                <th style="font-size: 100% ; color: white" class="text-left fonte">Saída</th>
                                            </tr>
                                        </thead>
                                        <tbody class="fonte">
                                            <tr v-for="(item, index) in item.items" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                                <td style="font-size: 100%" class="text-left">{{item.idFluxoBancario}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.tipo == "D" ? item.fornecedor : item.tipo == "R" ? item.doador : ''}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.descricao}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.data ? new Date(item.data).ddmmyyyy() : ''}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.numeroCheque}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.credito.toMoeda(true)}}</td>
                                                <td style="font-size: 100%" class="text-left">{{item.debito.toMoeda(true)}}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-card-text>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </master-page>
</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import BancoService from '../../../core/services/financeiro/BancoService';
import FornecedorService from "../../../core/services/financeiro/FornecedorService"
import TipoFluxoBancarioEnumService from '@/core/services/financeiro/TipoFluxoBancarioEnumService';

export default {
    data: () => ({
        service: new FluxoBancarioService(),
        filtro: {
            fornecedorId: 0,
            codigoInicio: 0,
            codigoFim: 0,
            dataInicial: new Date().yyyymmdd(),
            dataFinal: new Date().yyyymmdd(),
            bancoId: 1,
            tipo: "",
            layoutId: 1
        },
        bancos:[],
        situacoes:[],
        fornecedorService: new FornecedorService(), 
        fornecedores:[],
        isFornecedorLoading: false,
        onSearchFornecedor: null,
        bancoService: new BancoService(),
        bancos: [],
        item: {},
        fornecedoresLista:[],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        overlay: false,
        layouts: [
            {
                key: 1,
                value: "Layout Padrão"
            },
            {
                key: 2,
                value: "Layout Atividades"
            }
        ]

    }),
    methods: {
        Listar(){
            this.overlay = true;
            this.service.ListarComFiltro(this.filtro)
            .then(
                res => {
                    this.item = res.data;
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            ).finally(() => {
                this.overlay = false;
            });

        },        
        GerarRelatorio(){
            this.AbrirJanela('relatorioFluxoBancario');
        },
        LimparFiltros(){
            this.filtro = {
                fornecedorId: null,
                codigoInicio: 0,
                codigoFim: 0,
                dataInicial: new Date().yyyymmdd(),
                dataFinal: new Date().yyyymmdd(),
                bancoId: 1,
                tipo: ""
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota, 
                query:{
                    fornecedorId: this.filtro.fornecedorId,
                    codigoInicio: this.filtro.codigoInicio,
                    codigoFim: this.filtro.codigoFim,
                    dataInicial: this.filtro.dataInicial,
                    dataFinal: this.filtro.dataFinal,
                    bancoId: this.filtro.bancoId,
                    tipo: this.filtro.tipo,
                    layoutId: this.filtro.layoutId
                }
            });
            window.open(routeLink.href,'_blank');
        }, 
    },
    watch:{
        onSearchFornecedor(val){
            if(this.isFornecedorLoading) return;
            if(!val) return;

            this.isFornecedorLoading = true;
            this.fornecedorService.AutoComplete(val)
            .then(
                res=>{
                    this.fornecedores = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isFornecedorLoading = false))
        }
    },
    mounted(){
        this.fornecedorService.ListarTudo().then(
            res=>{
                this.fornecedoresLista = res.data.items;
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )

        this.bancoService.ListarTudo().then(
            res=>{
                let resultado = res.data.items;

                let ordenado = resultado.sort(function(a,b){
                    if(a.nome > b.nome){
                        return 1;
                    }
                    if(a.nome < b.nome){
                        return -1;
                    }
                    return 0;
                });

                ordenado.forEach(x => {
                    if(x.situacao == 'A'){
                        this.bancos.push(x);
                    }
                });
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )

        let tipoFluxoBancarioEnumService = new TipoFluxoBancarioEnumService();
        tipoFluxoBancarioEnumService.Listar()
            .then(
                res => {
                    this.situacoes = res.data;
                    this.situacoes.unshift({
                      key: "",
                      value: "< TODOS >"
                    });
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
    }
}

</script>

<style>
    .text{
        /* color: rgb(229, 118, 26); */
        color: rgb(255, 255, 255);
        font-weight: bold;
        font-size: 18px;
    }
</style>